import React from "react"
import TopBar from "./tobBar"
import Footer from "./footer"
import Navbar from "../inc/navbar"

export default function Layout({ children }) {

    return (
        <React.Fragment>
            <TopBar />
            <Navbar/>
                {children}
            <Footer />
        </React.Fragment>
    )
}